import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconLinePlotAlt2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 2.25C3.41421 2.25 3.75 2.58579 3.75 3V20.25H21C21.4142 20.25 21.75 20.5858 21.75 21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V3C2.25 2.58579 2.58579 2.25 3 2.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.7463 13.9254C21.7875 14.3376 21.4868 14.7051 21.0746 14.7463C16.1518 15.2386 12.2823 16.1236 6.29545 18.6894C5.91473 18.8526 5.47382 18.6762 5.31065 18.2955C5.14748 17.9148 5.32385 17.4739 5.70457 17.3107C11.83 14.6855 15.8482 13.7615 20.9254 13.2538C21.3375 13.2126 21.7051 13.5133 21.7463 13.9254Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1718 6.73011C21.575 6.63524 21.8249 6.23147 21.7301 5.82827C21.6352 5.42506 21.2314 5.17511 20.8282 5.26998C13.335 7.03308 7.3976 12.5427 5.8602 14.0705C5.72256 14.2072 5.58571 14.345 5.45315 14.4868L5.45139 14.4887L5.45041 14.4897C5.16856 14.7932 5.18613 15.2678 5.48967 15.5496C5.7932 15.8315 6.26814 15.8135 6.54999 15.51L6.55349 15.5062C6.67243 15.38 6.79451 15.2567 6.91753 15.1344C8.4189 13.6425 14.1064 8.39255 21.1718 6.73011Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconLinePlotAlt2 as ReactComponent };
